// extracted by mini-css-extract-plugin
export default {"inputsContainer":"styles_inputsContainer__FKeEE","toolsHolder":"styles_toolsHolder__izYdu"};